export const yardsGainedLabels = [
  { hasNotch: true, label: '-10', position: -10 },
  { hasNotch: true, label: '-5', position: -5 },
  {
    hasNotch: true,
    label: '0',
    position: 0,
  },
  { hasNotch: true, label: '5', position: 5 },
  {
    hasNotch: true,
    label: '10',
    position: 10,
  },
  {
    hasNotch: true,
    label: '15',
    position: 15,
  },
  {
    hasNotch: true,
    label: '20',
    position: 20,
  },
  {
    hasNotch: true,
    label: '25',
    position: 25,
  },
];

export const qbDropDepthLabels = [
  { hasNotch: true, label: '0', position: 0 },
  {
    hasNotch: true,
    label: '5',
    position: 5,
  },
  {
    hasNotch: true,
    label: '10',
    position: 10,
  },
  {
    hasNotch: true,
    label: '15',
    position: 15,
  },
];

export const qbTimeToThrowLabels = [
  { hasNotch: true, label: '0', position: 0 },
  {
    hasNotch: true,
    label: '1',
    position: 1,
  },
  {
    hasNotch: true,
    label: '2',
    position: 2,
  },
  {
    hasNotch: true,
    label: '3',
    position: 3,
  },
  {
    hasNotch: true,
    label: '4',
    position: 4,
  },
  {
    hasNotch: true,
    label: '5',
    position: 5,
  },
];

export const depthOfTargetLabels = [
  { hasNotch: true, label: '-5', position: -5 },
  {
    hasNotch: true,
    label: '0',
    position: 0,
  },
  {
    hasNotch: true,
    label: '5',
    position: 5,
  },
  {
    hasNotch: true,
    label: '10',
    position: 10,
  },
  {
    hasNotch: true,
    label: '15',
    position: 15,
  },
  {
    hasNotch: true,
    label: '20',
    position: 20,
  },
  {
    hasNotch: true,
    label: '25',
    position: 25,
  },
  {
    hasNotch: true,
    label: '30',
    position: 30,
  },
  {
    hasNotch: true,
    label: '35',
    position: 35,
  },
  {
    hasNotch: true,
    label: '40',
    position: 40,
  },
];
